import { Fragment } from "react";

import SourceSelection from "@/components/ai-training/source-selection/source-selection";

const KnowledgeBase = () => {
    return (
        <Fragment>
            <>
                <SourceSelection />
            </>
        </Fragment>
    );
};

export default KnowledgeBase;
